import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import WhiteButton from "../../../../components/buttons/WhiteButton"
import { saveEvent } from "../../../../utils/apis/user-service"
import { NEW_PLATFORM_HOME_LOGO_BLACK } from "../../../../utils/Constants"
import { EventType } from "../../../../utils/enums/EventType"
import { useAuthStore } from "../../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../../utils/stores/useUserStore"
import CloseButton from "../../components/CloseButton"

const HealthAssessmentSuccessPage = () => {
  const { sendEvent } = useCreateEvent()
  const { auth } = useAuthStore()
  const idToken = auth.idToken
  const { userData } = useUserStore()
  const email = userData.email
  const navigate = useNavigate()

  useEffect(() => {
    if (!email) return
    saveEvent(
      email,
      EventType.PageView,
      (success) => { console.log() },
      (error) => { console.log(error) },
      "health_assessment_success_page"
    )

    void sendEvent({
      event: NewEventType.PAGE_VIEW,
      sub_category: "health_assessment_success_page",
    })
  }, [])

  const onDismissClick = async () => {
    navigate("/home")
    if (!email || !idToken) return
    saveEvent(
      email,
      "dismiss_button_click",
      (success) => { console.log() },
      (error) => { console.log(error) },
      "health_assessment_success_page"
    )
    await sendEvent({
      event: NewEventType.BUTTON_CLICK,
      sub_category: "dismiss_button",
    })
  }

  const onCloseClick = async () => {
    navigate("/home")
    if (!email) return
    saveEvent(
      email,
      "close_button_click",
      (success) => { console.log() },
      (error) => { console.log(error) },
      "health_assessment_success_page"
    )
    await sendEvent({
      event: NewEventType.BUTTON_CLICK,
      sub_category: "action_button",
      event_metadata: { action: "close_success_page" }
    })
  }

  // ********************************************************************************
  return (
    <div className="w-full h-screen flex flex-col items-center">
      <div className="w-full h-[100px] flex items-center justify-center border-b border-solid border-black md:h-[200px]">
        <div className="w-[90%] h-[90%] flex items-center justify-between md:w-[80%]">
          <div className="flex items-center">
            <img className="mr-[10px]" src="/images/new-platform/logos/holifya-logo-no-text.svg" alt="holifya-logo" />
            <div className="font-bold text-[12px] leading-[17px]">Questionario | Health Assessment</div>
          </div>
          <CloseButton onClick={onDismissClick} />
        </div>
      </div>
      <div className="w-full h-[calc(100%-220px)] overflow-y-auto scrollbar-hide md:w-[80%] md:mt-[30px] md:h-fit">
        <div className="w-full h-full p-[20px] font-normal text-[16px] leading-[26px]">
          Fantastico! 🎉 <br />
          Ora che hai risposto a tutte le domande la tua Medical Equipe ha molte più informazioni su di te.
          Ricordati di rispondere al questionario di check-up, disponibile sempre in Home ( <span><img className="align-middle inline-block m-0 p-0 h-auto w-auto" src={NEW_PLATFORM_HOME_LOGO_BLACK} /></span> ),  per condividere aggiornamenti e progressi!
        </div>
      </div>
      <div className="w-full h-[120px] flex items-center justify-center">
        <div className="w-[90%] h-[50px]">
          <WhiteButton
            text="Chiudi"
            onClick={onCloseClick}
            fontSize={16}
            uppercase={false}
          />
        </div>
      </div>
    </div>
  )
}

export default HealthAssessmentSuccessPage
